<template>
    <div class="content_box">
        <div class="content">
            <div class="title">
                <span>销售统计</span><br><br>
            </div>
            <div class="search_box">
                <el-form class="form-list" label-width="80px">
                    <el-form-item class="form_item noborder date_picker" label="日期选择">
                        <DatePicker :date="trendTime" @dateSelect="dateSelect"></DatePicker>
                    </el-form-item>
                    <el-form-item label="统计维度">
                        <el-radio-group v-model="data_type" size="small">
                            <el-radio-button class="radio" label="team">按销售团队</el-radio-button>
                            <el-radio-button class="radio" label="mate">按业务人员</el-radio-button>
                            <el-radio-button class="radio" label="product">按产品型号</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                    <div>
                        <div class="button export" @click="exportSalesCount"
                            v-if="$store.state.type == 'pc'  && roleCheck('102-100-103-102')">
                            <span>导出</span>
                        </div>
                    </div>

                </el-form>
            </div>
            <el-table :data="salesList" :fit="true" style="width:100%" highlight-current-row show-summary
                :summary-method="getSummaries">
                <el-table-column prop="val" label="序号" fixed>
                    <template slot-scope="scope">{{
                    scope.$index + 1 > 9 ? scope.$index + 1 : "0" + (scope.$index + 1)}}
                    </template>
                </el-table-column>
                <el-table-column prop="val" :label="count_type" width="130" fixed>
                    <template slot-scope="scope">
                        <span>{{scope.row.val || '未分类'}}</span>
                        <el-button v-if=" roleCheck('102-100-103-102') && $store.state.type == 'pc'" type="text" title="导出订单明细"
                            @click="exportSalesOrder(scope.row)" class="download"><i class="el-icon-download"></i>
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="saleNum" label="销量" width="130">
                </el-table-column>
                <el-table-column prop="totalSaleAmount" label="总销售额" width="140">
                    <template slot="header" slot-scope="scope">
                        <div class="table_label">
                            <span>总销售额</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="top-start"
                                content="未经扣除折扣/优惠等费用的销售额">
                                <img class="icon-tip tip_padd" src="../../../assets/images/ico/ic_tip.png" alt="">
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.totalSaleAmount) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="saleAmount" label="实际销售额" width="140">
                    <template slot="header" slot-scope="scope">
                        <div class="table_label">
                            <span>实际销售额</span>
                            <el-tooltip popper-class="shadow" effect="light" placement="top-start"
                                content="经过扣除折扣/优惠等费用的销售额">
                                <img class="icon-tip tip_padd" src="../../../assets/images/ico/ic_tip.png" alt="">
                            </el-tooltip>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.saleAmount) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="saleAmountRate" label="销售额贡献率" width="110">
                </el-table-column>
                <el-table-column prop="gross_profit" label="毛利润" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.gross_profit) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="gross_profit_rate" label="毛利率" width="130">
                </el-table-column>
                <el-table-column prop="gross_rate" label="毛利润贡献率" width="110">
                </el-table-column>
                <el-table-column prop="refundNum" label="退款量">
                    <template slot-scope="scope">
                        <span>{{ scope.row.refundNum || '--' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refundAmount" label="退款额" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.refundAmount) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="refundRate" label="退款率">
                </el-table-column>
                <el-table-column prop="total_cost" label="总成本" width="140">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.total_cost) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="total_cost_rate" label="总成本占比" width="130">
                </el-table-column>
                <el-table-column prop="send_fee" label="发货费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.send_fee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="send_fee_rate" label="发货费占比" width="100">
                </el-table-column>
                <el-table-column prop="headFee" label="头程">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.headFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="fbaFee" label="尾程" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.fbaFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sellingFee" label="平台费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.sellingFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="sellingFee_rate" label="平台费占比" width="100">
                </el-table-column>
                <el-table-column prop="promotionFee" label="促销费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.promotionFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="promotionFee_rate" label="促消费占比" width="100">
                </el-table-column>
                <el-table-column prop="adsFee" label="广告费" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.adsFee) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="adsFeeRate" label="广告费占比" width="100">
                </el-table-column>
                <el-table-column prop="cgPrice" label="采购成本" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.cgPrice) || '--'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="cgPriceRate" label="采购成本占比" width="110">
                </el-table-column>
                <el-table-column prop="operatingFee" label="营销费用" width="130">
                    <template slot-scope="scope">
                        <span>{{formatNumber(scope.row.operatingFee) || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>

export default ({
    name: 'sales-count',
    data() {
        return {
            trendTime: [],
            searchData: {
                start_time: 0,
                end_time: 0,
                data_type: '',
                // page_size: 10,
                // page: 1,
            },
            trendOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6;
                },
                shortcuts: [{
                    text: '最近7天',
                    onClick(picker) {
                        const end = Date.now();
                        const start = end - 3600 * 1000 * 24 * 6;
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近30天',
                    onClick(picker) {
                        const end = Date.now();
                        const start = end - 3600 * 1000 * 24 * 29;
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近90天',
                    onClick(picker) {
                        const end = Date.now();
                        const start = end - 3600 * 1000 * 24 * 89;
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            total: 0,
            salesList: [],
            data_type: '',
            count_type: '销售团队',
            dataSum: [],
            productList: [],
        }
    },
    watch: {
        'trendTime': function (nTime) {
            this.searchData.start_time = this.formDate(nTime[0], 'YYYY-MM-DD');
            this.searchData.end_time = this.formDate(nTime[1], 'YYYY-MM-DD');
            if (this.searchData.data_type) {
                this.getSalesCountList();
            }

        },
        'data_type': function (n) {
            this.searchData.data_type = n;
            if (n == 'team') {
                this.count_type = '销售团队';
            } else if (n == 'mate') {
                this.count_type = '业务人员';
            } else {
                this.count_type = '产品型号';
            }
            this.getSalesCountList();
        }
    },
    created() {
        this.trendTime = this.setDate(new Date().getDate());
        this.data_type = 'team';
        this.getSalesProduct();
        // this.getSalesCountList();
    },
    methods: {
        dateSelect(date) {
			this.trendTime = date ? [...date] : '';
		},
        dateSelect(date) {
            this.trendTime = [...date];
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
        },
        getSalesCountList() {
            this.api.getSalesCountList(this.searchData).then(data => {
                var list = data.data.result.dataList || [];
                var that = this;
                if (this.data_type == 'product') {
                    list.forEach(function (item, index, arr) {
                        that.productList.forEach(product => {
                            if (product.id == item.val) {
                                arr[index].val = product.dictItem;
                                return;
                            }
                        });
                    });
                }
                this.salesList = list;
                this.dataSum = data.data.result.dataAll || [];
            })
        },
        getSummaries() {
            if (this.dataSum) {
                var arr = ['合计', '', this.dataSum.saleNum, this.formatNumber(this.dataSum.totalSaleAmount), this.formatNumber(this.dataSum.saleAmount), this.dataSum.saleAmountRate, this.formatNumber(this.dataSum.gross_profit), this.dataSum.gross_profit_rate, this.dataSum.gross_rate, this.dataSum.refundNum, this.formatNumber(this.dataSum.refundAmount), this.dataSum.refundRate, this.formatNumber(this.dataSum.total_cost), this.dataSum.total_cost_rate, this.formatNumber(this.dataSum.send_fee), this.dataSum.send_fee_rate, this.formatNumber(this.dataSum.headFee), this.formatNumber(this.dataSum.fbaFee), this.formatNumber(this.dataSum.sellingFee), this.dataSum.sellingFee_rate, this.formatNumber(this.dataSum.promotionFee), this.dataSum.promotionFee_rate, this.formatNumber(this.dataSum.adsFee), this.dataSum.adsFeeRate, this.formatNumber(this.dataSum.cgPrice), this.dataSum.cgPriceRate, this.formatNumber(this.dataSum.operatingFee)]
                return arr;
            }
        },
        getSalesProduct() {
            this.api.getSalesProduct().then(data => {
                this.productList = data.data.result_list || [];
            })
        },
        exportSalesOrder(row) {
            if(new Date(this.searchData.end_time).getTime() - new Date(this.searchData.start_time).getTime() > 86400000 * 7){
                this.$message.warning(`筛选时间不能大于7天！`);
                return;
            }
            var exportReq = {};
            var val_id = parseInt(row.val_id) || -1;
            var name = row.val || '未分类';
            if (this.data_type == 'team') {
                exportReq = { start_time: this.searchData.start_time, end_time: this.searchData.end_time, team_id: val_id, name: name }
            }
            else if (this.data_type == 'mate') {
                exportReq = { start_time: this.searchData.start_time, end_time: this.searchData.end_time, mate_id: val_id, name: name }
            }
            else if (this.data_type == 'product') {
                exportReq = { start_time: this.searchData.start_time, end_time: this.searchData.end_time, product_type: val_id, name: name }
            }
            this.api.exportSalesOrder(exportReq).then(data => {
            })
        },
        exportSalesCount() {
            this.api.exportSalesCount(this.searchData).then(data => {
            })
        },
    }
})
</script>
<style lang="less" scoped>
.content {
    background-color: @colorWhite;

    .radio {
        padding-right: 20px;
    }
    /deep/ .date_picker{
        width: 320px;
    }
    .table_label {
        .flexLayout();
        flex-wrap: nowrap;

        .tip_padd {
            padding-top: 5px;
        }
    }

    /deep/.el-radio-button__inner {
        border: 1px solid @colorLine;
        border-radius: 4px!important;
        width: 100px;
    }

    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        background-color: @colorBlue2;
        color: @colorWhite;
        box-shadow: none;
    }
    .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        box-shadow: none;
    }

    .download {
        padding: 0;
    }

}
</style>






// WEBPACK FOOTER //
// src/view/statistics/sales/sales-count.vue